var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClassBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#8C52FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 20V16C22 14.8954 21.1046 14 20 14C18.8954 14 18 14.8954 18 16V20M18 18H22M16 23H24M16 26H20M15 30H25C27.2091 30 29 28.2091 29 26V14C29 11.7909 27.2091 10 25 10H15C12.7909 10 11 11.7909 11 14V26C11 28.2091 12.7909 30 15 30Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassBorder);
export default __webpack_public_path__ + "static/media/class-border.94a4eb32eb9a66828cee8f21745e3ebb.svg";
export { ForwardRef as ReactComponent };